<template>
    <div class="MuiBox-root css-3d0ymh">
        <div class="MuiBox-root css-19vwmxk" data-testid="screen-business_details" tabindex="-1">
            <div class="MuiBox-root css-1n2tziu">
                <div class="MuiGrid-root MuiGrid-container css-15zova9 slide-up-enter-done" transition="250">
                    <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-ms-3 MuiGrid-grid-md-4 css-4lvwcn">
                        <div class="MuiBox-root css-1yu9eo3">
                            <div class="MuiGrid-root css-skpbsy">
                                <div class="MuiGrid-root css-vnk25j" type="lottie">
                                    <div>
                                        <Freezeframe
                                            src="/images/free-animated-icon-fast-forward-7740748.gif"
                                        ></Freezeframe>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-ms-1 css-se8e58">
                        <div class="MuiBox-root css-8atqhb"></div>
                    </div>
                    <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-4 MuiGrid-grid-md-7 css-xjtbym">
                        <Number
                            :deadline_word="deadline_word"
                            v-model="info"
                            :start_number="$route.params.number"
                            :form_type="form_type"
                        ></Number>
                    </div>
                </div>
            </div>
            <div class="css-1l6i970">
                <div class="css-1c73k7k">
                    <div class="bottom-button-wrap">
                        <BottomButton
                            v-if="info.detected_form_type == form_type"
                            :active="info.status && !is_loading ? true : false"
                            @click.native="nextStraight"
                            text="Next"
                            class_b="button-next"
                        ></BottomButton>


                        <template v-if="info.detected_form_type != form_type">
                            <template v-for="(bottomButton, index) in bottomButtons">
                                <BottomButton
                                    :active="info.status && !is_loading ? true : false"
                                    @click.native="next(bottomButton.type)"
                                    :text="bottomButton.text"
                                    :class_b="index == 0 && bottomButtons.length > 1 ? 'button-next button-next_first' : 'button-next'"
                                ></BottomButton>
                            </template>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Freezeframe from '@/components/Freezeframe.vue'
import BottomButton from '@/ui/Bottom-Button.vue'
import Number from '@/components/Number.vue'
import http from "@/api/http"
import {to_top} from '@/helper.js'

export default {
    components: {
        Number,
        BottomButton,
        Freezeframe
    },
    props: {
        deadline_word: String,
        form_type: String,
        part_url: String,
        part_url_next: String,
    },
    data() {
        return {
            is_loading: false,
            info: {
                issuesMessage: '',
                detected_form_type: '',
                status: false,
                is_associated: true
            }
        }
    },
    methods: {
        async nextStraight() {
            this.is_loading = true
            let { data } = await http.post(this.part_url, {
                number: this.info.number,
                is_associated: true
            });

            if (data.res) {
                this.$router.push({ path: '/' + this.part_url + '/' + this.part_url_next + '/' + data.data })
            } else {
                this.is_loading = false
            }
        },
        async next(type) {
            if (type == 'REV') {
                this.$router.push({ path: '/trademark-revival/step-1/' + this.info.number })
            } else if (type == 'REN') {
                this.$router.push({ path: '/trademark-renewal/step-1/' + this.info.number })
            } else if (type == 'SOUE') {
                this.$router.push({ path: '/statement-of-use-extension/step-1/' + this.info.number })
            } else if (type == 'OA') {
                this.$router.push({ path: '/trademark-office-action/step-1/' + this.info.number })
            } else if (type == 'SOU') {
                this.$router.push({ path: '/statement-of-use/step-number/' + this.info.number })
            } else {
                to_top()
                this.$router.push({ path: '/' })
            }
        }
    },
    computed: {
        bottomButtons () {
            let arr = []
            let types = {
                REV: 'Trademark Revival',
                REN: 'Trademark Renewal',
                SOUE: 'Statement Of Use Extension',
                OA: 'Office Action',
                SOU: 'Statement Of Use',
            }

            if (this.info.detected_form_type.length == 0) {
                arr.push({
                    text: "<img class='button-arrow button-arrow_reverse' src='/images/arrow-button.png'> Main Page",
                    type: ''
                })
            } else if (this.info.detected_form_type.length > 0) {
                if (
                    (this.info.detected_form_type == 'SOU' || this.info.detected_form_type == 'SOUE') &&
                    (this.form_type == 'REV' || this.form_type == 'REN' || this.form_type == 'OA')
                ) {
                    arr.push({
                        text: "<img class='button-arrow' src='/images/arrow-button.png'>" + types['SOU'],
                        type: 'SOU'
                    })
                    arr.push({
                        text: "<img class='button-arrow' src='/images/arrow-button.png'>" + types['SOUE'],
                        type: 'SOUE'
                    })
                } else {
                    arr.push({
                        text: "<img class='button-arrow' src='/images/arrow-button.png'>" + types[this.info.detected_form_type],
                        type: this.info.detected_form_type
                    })
                }
            }

            return arr
        }
    }
}
</script>
<style>
.button-next_first {
    margin-right: 5px!important;
}
.button-arrow {
    display: inline-block;
    color: #16BDC6;
    font-style: initial;
    font-size: 60px;
    height: 24px;
    line-height: 0;
}
.button-arrow_reverse {
    transform:rotate(180deg);
    -webkit-transform:rotate(180deg); /* Safari and Chrome */
}
</style>
